module.exports = __webpack_public_path__ + "img/2018-09-5.666b3817.jpeg";